import { render, staticRenderFns } from "./ExclamationTriangle.vue?vue&type=template&id=3ecc87b0&"
import script from "./ExclamationTriangle.vue?vue&type=script&lang=js&"
export * from "./ExclamationTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports